<!-- Componente completo -->
<template>
  <section class="flex flex-col md:flex-row bg-[#F8F8F8] min-h-[550px] mt-20">
    <!-- Izquierda -->
    <div
      class="w-full md:w-1/2 flex flex-col justify-center px-6 md:px-20 py-10 space-y-6"
    >
      <h1 class="text-4xl font-semibold text-[#101541] leading-tight">
        ¿En qué podemos ayudarte hoy?
      </h1>
      <p class="text-base md:text-lg text-gray-700">
        Conoce más sobre nuestras soluciones seleccionando un área de interés.
      </p>
      <div class="flex flex-col sm:flex-row gap-4">
        <select
          v-model="selectedCategory"
          class="w-full sm:w-1/2 p-3 rounded border text-sm"
        >
          <option
            v-for="(options, category) in optionsByCategory"
            :key="category"
            :value="category"
          >
            {{ category }}
          </option>
        </select>

        <select
          v-model="selectedOption"
          class="w-full sm:w-1/2 p-3 rounded border text-sm"
        >
          <option
            v-for="item in optionsByCategory[selectedCategory]"
            :key="item.value"
            :value="item.value"
          >
            {{ item.label }}
          </option>
        </select>
      </div>
    </div>

    <!-- Derecha con imagen + overlay + texto -->
    <div class="w-full md:w-1/2 max-h-[550px] relative overflow-hidden">
      <img
        v-if="selectedOption"
        :src="images[selectedOption]"
        alt="Imagen relacionada"
        class="w-full h-full object-cover"
      />
      <div class="absolute inset-0 bg-black/40"></div>

      <!-- Overlay de información sobre la imagen -->
      <transition name="fade" mode="out-in">
        <div
          v-if="selectedOption"
          :key="selectedOption"
          class="absolute inset-0 flex flex-col justify-center px-6 md:px-12"
        >
          <div
            class="bg-white/90 backdrop-blur-sm p-6 md:p-8 rounded-2xl max-w-xl mx-auto md:mx-0 space-y-3"
          >
            <h2
              class="text-xl md:text-2xl font-semibold text-[#101541] text-left"
            >
              {{
                optionsByCategory[selectedCategory].find(
                  (opt) => opt.value === selectedOption
                )?.label
              }}
            </h2>
            <p class="text-sm md:text-base text-gray-700 text-left">
              {{ descriptions[selectedOption] }}
            </p>
            <div class="flex justify-end">
              <RouterLink
                :to="`/${routeMap[selectedOption]}`"
                class="inline-block px-5 py-2 bg-[#F37021] text-white font-semibold rounded-full hover:bg-[#d45e14] transition"
              >
                Conoce más →
              </RouterLink>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </section>
</template>

<script setup>
import { ref, watch } from "vue";

const selectedCategory = ref("Daños");
const selectedOption = ref("responsabilidad");

const routeMap = {
  responsabilidad: "responsabilidad-civil",
  paquete: "paquete-empresarial",
  construccion: "construccion",
  terrorismo: "terrorismo",
  ciberseguridad: "ciberseguridad",
  fianzas: "fianzas",
  especiales: "especiales",
  transporte: "transporte",
  aviacion: "aviacion",
  embarcaciones: "embarcaciones",
  vida_colectivo: "seguro-de-vida-colectivo",
  medico_colectivo: "gastos-medicos-colectivo",
  accidentes_colectivo: "accidentes-colectivo",

  flotillas: "flotillas",
};

const optionsByCategory = {
  Daños: [
    { value: "responsabilidad", label: "Responsabilidad civil" },
    { value: "paquete", label: "Paquete empresarial" },
    { value: "construccion", label: "Construcción" },
    { value: "terrorismo", label: "Terrorismo" },
    { value: "ciberseguridad", label: "Ciberseguridad" },
    { value: "fianzas", label: "Fianzas" },
    { value: "especiales", label: "Especiales" },
    { value: "transporte", label: "Transporte" },
    { value: "aviacion", label: "Aviación" },
    { value: "embarcaciones", label: "Embarcaciones" },
  ],
  Beneficios: [
    { value: "vida_colectivo", label: "Seguro de vida colectivo" },
    { value: "medico_colectivo", label: "Gastos médicos colectivo" },
    { value: "accidentes_colectivo", label: "Accidentes colectivo" },
  ],
  Autos: [{ value: "flotillas", label: "Flotillas" }],
};

const descriptions = {
  responsabilidad:
    "Protección legal ante daños a terceros por parte de tu empresa.",
  paquete: "Un conjunto integral de coberturas para negocios.",
  construccion: "Cubre riesgos en obras y proyectos constructivos.",
  terrorismo: "Protección ante actos de terrorismo que afecten tu negocio.",
  ciberseguridad: "Protege tus activos digitales contra amenazas cibernéticas.",
  fianzas: "Garantiza tus obligaciones contractuales.",
  especiales: "Soluciones personalizadas para necesidades únicas.",
  vida_colectivo: "Seguro de vida para todos tus empleados.",
  medico_colectivo: "Cobertura médica para personal laboral.",
  accidentes_colectivo: "Protección ante accidentes laborales.",
  flotillas: "Cobertura para múltiples vehículos empresariales.",
  aviacion: "Protección especializada para aeronaves.",
  embarcaciones: "Seguro para barcos o transporte marítimo.",
  transporte: "Cubre daños o pérdidas en el traslado de bienes.",
};

const images = {
  responsabilidad: "/images/daños.png",
  paquete: "/images/daños.png",
  construccion: "/images/daños.png",
  terrorismo: "/images/daños.png",
  ciberseguridad: "/images/daños.png",
  fianzas: "/images/daños.png",
  especiales: "/images/daños.png",
  aviacion: "/images/daños.png",
  embarcaciones: "/images/daños.png",
  transporte: "/images/daños.png",
  vida_colectivo: "/images/beneficios.png",
  medico_colectivo: "/images/beneficios.png",
  accidentes_colectivo: "/images/beneficios.png",
  flotillas: "/images/autos.png",
};

watch(selectedCategory, (newCategory) => {
  selectedOption.value = optionsByCategory[newCategory][0].value;
});
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
